import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import IconLinkContent from './IconLinkContent.vue';
import { NavigationLink } from '~/data/navigation_links_hub_left';
interface Props {
  item: NavigationLink;
  sideNavClosed?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'IconLink',
  props: {
    item: null,
    sideNavClosed: { type: Boolean }
  },
  setup(__props: any) {

const { $mzAnalyticsApi, route } = useContext();


const trackUserClick = (name: string, link: string) => {
  let productArea = 'hub';
  if (route.value.path.includes('/folder')) {
    productArea = 'profile';
  }

  $mzAnalyticsApi({
    event: 'click',
    name: name.toLocaleLowerCase().replaceAll(' ', '_'),
    productArea,
  });
};

return { __sfc: true,$mzAnalyticsApi, route, trackUserClick, IconLinkContent }
}

})